import { toggleActivityFeed, setUnseenActivityCount } from '../actions/toggleActivityFeed';
import loadActivityFeed from './loadActivityFeed';
import { logUsage } from 'owa-analytics';

export default function toggleActivityFeedOpx(visibility: boolean, unseenActivityCount: number) {
    toggleActivityFeed(visibility);
    setUnseenActivityCount(unseenActivityCount);

    logUsage('ActivityFeed_ActionClicked', {
        action: 'toggleNotificationPane_' + String(visibility) + ':' + String(unseenActivityCount),
    });
    // We should load the activity feed when the pane is opened to make the markItemsAsSeen call
    if (visibility) {
        loadActivityFeed();
    }
}
